/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IWindowService} from 'angular';

/**
 * service that manages the golobal window variable for piwik
 */
export default class PiwikService {

    static $inject = ['$window'];

    private _paq: Array<any> = [];  //this seems to be a piwik config array of arrays thing that has a string as key in the first entry of every
                                    // child array

    /* @ngInject */
    constructor(private $window: IWindowService) {
    }

    getPiwikUrl(): string {
        return 'https://piwik.dvbern.ch/';
    }

    public get paq(): Array<any> {
        return this._paq;
    }

    public set paq(value: Array<any>) {
        this._paq = value;

    }

    public push(pairArr: Array<any>) {
        this.$window['_paq'] = this.$window['_paq'] || [];
        this.$window['_paq'].push(pairArr);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/PiwikService.ts